import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext';
import { BsThreeDotsVertical } from "react-icons/bs";
import NotificationService from '../services/NotificationService';
import { formatTimeAgo } from '../utils/DateFormat';


export default function AppHeader() {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const { logout, user } = useAuth();
    const [notifications, setNotifications] = useState([]);
    const [activeMenuId, setActiveMenuId] = useState(null);
    const hasUnread = notifications.some((n) => !n.is_read);
    const capitalizeFirst = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);



    useEffect(() => {
        const getNotifications = async () => {
            if (!user?.id) return;
            try {
                const response = await NotificationService.getByUser(user.id);
                setNotifications(response?.data?.data || []);
            } catch (error) {
                console.error("Error fetching notifications", error);
            }
        };

        getNotifications();
    }, [user?.id]);


    useEffect(() => {
        if (dropdownRef.current) {
            const menu = dropdownRef.current;
            if (isOpen) {
                menu.classList.add('show');
            } else {
                menu.classList.remove('show');
            }
        }
        document.getElementsByTagName('body')[0].className = '';
    }, [isOpen]);

    const toggleDropDown = () => {
        setIsOpen((prevState) => !prevState);
    }

    const handleDotsClick = (e, id) => {
        e.stopPropagation(); // prevent dropdown from closing
        e.preventDefault();  // prevent default anchor behavior
        setActiveMenuId((prev) => (prev === id ? null : id));
    };

    const handleMarkAsRead = async (id) => {
        try {
            const response = await NotificationService.markAsRead(id);
            if (response.status === 200) {
                console.log("Marked as read:", id);
                setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)));
                setActiveMenuId(null);
            }
        } catch (error) {
            console.log("Error in marking notifications as read.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    }
    const handleDelete = async (id) => {
        try {
            const response = await NotificationService.delete(id);
            if (response.status === 200) {
                console.log("Deleted:", id);
                setNotifications((prev) => prev.filter((n) => n.id !== id));
                setActiveMenuId(null);
            }
        } catch (error) {
            console.log("Error in deleting notifications.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    return (
        <>
            <nav className="navbar navbar-expand-md navbar-light d-none d-md-flex" id="topbar">
                <div className="container-fluid">
                    {/* <--Form --> */}
                    <form className="form-inline me-4 d-none d-md-flex">
                        <div className="input-group input-group-flush input-group-merge input-group-reverse" data-list='{"valueNames": ["name"]}'>
                            {/* <--Input --> */}
                            {/* <input type="search" className="form-control dropdown-toggle list-search" data-bs-toggle="dropdown" placeholder="Search" aria-label="Search" /> */}
                            {/* <--Prepend --> */}
                            <div className="input-group-text">
                                <i className="fe fe-search"></i>
                            </div>
                        </div>
                    </form>
                    {/* <--User --> */}
                    <div className="navbar-user">
                        {/* <--Dropdown --> */}
                        <div className="dropdown me-4 d-none d-md-flex">
                            {/* <--Toggle --> */}
                            <button className="navbar-user-link" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className={`icon ${hasUnread > 0 ? 'active' : ''}`}>
                                    <i className="fe fe-bell fs-4"></i>
                                    {/* {hasUnread && (
                                        <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                            <span className="visually-hidden">New alerts</span>
                                        </span>
                                    )} */}
                                </span>
                            </button >
                            {/* <--Menu --> */}
                            <div className="dropdown-menu dropdown-menu-end dropdown-menu-card">
                                <div className="card-header">
                                    {/* <--Title --> */}
                                    <h5 className="card-header-title">
                                        Notifications
                                    </h5>
                                    {/* <--Link --> */}
                                    <a href="#!" className="small">
                                        View all
                                    </a>
                                </div>  {/* <--/ .card-header --> */}
                                <div className="card-body">
                                    {notifications.length > 0 ? (
                                        notifications.map((notification) => (
                                            <div className="list-group list-group-flush my-n3" key={notification.id}>
                                                <div className="list-group-item">
                                                    <div className={`row align-items-center ${!notification.is_read ? 'bg-primary bg-opacity-25 rounded' : ''}`}>
                                                        {/* Avatar */}
                                                        <div className="col-auto">
                                                            <div className="avatar">
                                                                <img
                                                                    src={notification?.triggeredBy?.avatar || "/assets/img/avatars/profiles/avatar-1.jpg"}
                                                                    alt="..."
                                                                    className="avatar-img rounded"
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Title & Message */}
                                                        <div className="col ms-n2">
                                                            <h4 className="mb-1">{notification?.title}</h4>
                                                            <p className="text-body-secondary mb-0">{capitalizeFirst(notification?.triggeredBy?.name) ?? 'Unkonwn'} {notification.message}</p>
                                                            <small className="text-muted">{formatTimeAgo(notification?.createdAt)}</small>
                                                        </div>

                                                        {/* Dots Menu */}
                                                        <div className="col-auto position-relative">
                                                            <button
                                                                className="btn btn-sm"
                                                                onClick={(e) => handleDotsClick(e, notification.id)}
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>

                                                            {activeMenuId === notification.id && (
                                                                <div
                                                                    className="dropdown-menu show"
                                                                    style={{ position: "absolute", right: 0, top: "100%", zIndex: 9999 }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <button
                                                                        onClick={() => handleMarkAsRead(notification.id)}
                                                                        className="dropdown-item"
                                                                    >
                                                                        Mark as read
                                                                    </button>
                                                                    <button
                                                                        onClick={() => handleDelete(notification.id)}
                                                                        className="dropdown-item text-danger"
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-center">No notifications</p>
                                    )}
                                </div>

                            </div>
                        </div>
                        {/* <--Dropdown --> */}
                        <div className="dropdown">
                            {/* <--Toggle --> */}
                            <button type='button' className="avatar avatar-sm avatar-online dropdown-toggle show" onClick={toggleDropDown} aria-haspopup="true" aria-expanded={isOpen ? "true" : "false"}>
                                <img src="/assets/img/avatars/profiles/avatar-1.jpg" alt="..." className="avatar-img rounded" />
                            </button >
                            {isOpen && (
                                <div className="dropdown-menu dropdown-menu-end" ref={dropdownRef} data-bs-popper="static">
                                    {user?.name && (<h6 className="dropdown-header">Welcome {user?.name.toUpperCase()}</h6>)}
                                    <Link to="/" className="dropdown-item">Profile</Link>
                                    <Link to="/" className="dropdown-item">Settings</Link>
                                    <Link to="/account" className="dropdown-item">Account</Link>
                                    <hr className="dropdown-divider" />
                                    <Link to="/" onClick={logout} className="dropdown-item">Logout</Link>
                                </div>
                            )
                            }
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}
